import { createFileRoute } from "@tanstack/react-router";
import { Distributions } from "@/components/Distributions";

function RouteComponent() {
  return <Distributions />;
}

export const Route = createFileRoute("/_authenticated/distributions/")({
  component: RouteComponent,
  staticData: { page: "distributions" },
});
